<div class="not_added" *ngIf="emptyMsg">
    <div class="user_img"><img src="./assets/img-new/client.png" alt="client"></div>
    <h4>No client added yet</h4>
    <button class="primary_btn" mat-raised-button color="primary" (click)="addClients()">
      <span class="sprite_icon plus_white"></span>
      <span>Add Clients</span>
    </button>
  </div>

  <div *ngIf="showList">
    <div class="breadcrumb_outer">
      <ul class="breadcrumb">
        <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
          <a (click)="goToPageLink(item)">{{ item }}</a>
        </li>
      </ul>
      <div class="right">
        <span>{{today}}</span>
      </div>
    </div>
    <div class="tag_powered_by">
      <span>Powered by: <b>Enertics</b></span>
    </div>
    <div class="Content_outer">
      <div class="content_view">
        <div class="row">
          <div class="col-md-12">
            <div class="listing_outer client_listing">
              <div class="filter_div">
                <div class="top">
                  <h4>Clients</h4>
                  <div class="right">
                    <div class="custom_search width_250">
                      <span class="sprite_icon search"></span>
                      <input type="text" class="form-control" placeholder="Search: Client, Industry or Country"
                        (input)="searchData($event.target.value)">
                    </div>
                    <!-- <button class="primary_btn" mat-raised-button (click)="addClients()">
                      <span class="sprite_icon plus_white"></span>
                      <span>Add Clients</span>
                    </button> -->
                  </div>
                </div>
              </div>
 


              <div class="listing_box four_col heading" *ngIf="showEmptyError == ''">
                <h4 class="left">Company</h4>
                Device&nbsp;<mat-slide-toggle class="slide_toggle" *ngIf="!DSP"  color="primary"  (change)="getAllClients($event)"></mat-slide-toggle>
                <mat-slide-toggle class="slide_toggle" *ngIf="DSP"  color="primary" [checked]="DSP" (change)="getAllClients($event)"></mat-slide-toggle>
                System&nbsp;
                <ngx-spinner></ngx-spinner>
                <!-- <h4 class="left1">
                   Licenses Type
                </h4> -->
               <div class="legendbox">
                  <div style="background-color:#999999"></div><strong>Offline</strong>
                  <div style="background-color:#72FF13"></div><strong>Healthy</strong>
                  <div style="background-color:#FAA700"></div><strong>Unsatisfactory</strong>
                  <div style="background-color:#ff2a1b"></div><strong>Unacceptable</strong>
               </div>

              </div>


              <div *ngIf="showEmptyError !== ''" class="no_result" >
                <p>{{showEmptyError}}</p>
              </div>

              <div class="listing_box four_col" *ngFor="let clients of mergeAp; trackBy: trackByFn;let idx = index;">

                <div class="left">
                  <div class="img_outer" style="cursor: pointer;"
                    (click)="seeUserAssets(clients.id, clients.company_name,'ALL')">
                    <img *ngIf="clients.image != null" src="{{clients.image}}"
                      onerror="this.src='./assets/img-new/client.png';" (error)="updateUrl($event)">
                    <img *ngIf="clients.image === null" src="" onerror="this.src='./assets/img-new/client.png';"
                      (error)="updateUrl($event)">
                  </div>
                  <div class="details" style="cursor: pointer;" (click)="seeUserAssets(clients.id, clients.company_name,'ALL')">
                    <h4>{{clients.company_name}}</h4>
                    <h5>{{clients?.industry_type || 'N/A'}}</h5>
                    <h6><span>
                        <img *ngIf="clients.country === 'India'" src="./assets/img-new/ind_flag.png" alt="India"
                          class="m_r_5">
                        <img *ngIf="clients.country === 'Canada'" src="./assets/img-new/flag.png" alt="India"
                          class="m_r_5">
                      </span>{{clients.country}}</h6>
                  </div>
                </div>
                <div class="statusAssets" *ngIf="assetsCounterSt">
                  <button  dataText="Offline" [style.background-color]="assetscolor.OFFLINE" (click)="viewAssetList('OFFLINE',clients.id,clients.company_name)">{{clients.offlineAssetCount}}</button><img src="./assets/arrow-{{clients.avg_offline_status}}-solid1.png">
                  <button  dataText="Healthy" [style.background-color]="assetscolor.HEALTHY" (click)="viewAssetList('HEALTHY',clients.id,clients.company_name)">{{clients.healthyAssetCount}}</button><img src="./assets/arrow-{{clients. avg_healthy_status}}-solid1.png">
                  <button  dataText="Unsatisfactory" [style.background-color]="assetscolor.UNACCEPTABLE" (click)="viewAssetList('UNHEALTHY',clients.id,clients.company_name)">{{clients.unhealthyAssetCount}}</button><img src="./assets/arrow-{{clients. avg_unhealthy_status}}-solid1.png">
                  <button  dataText="Unacceptable" [style.background-color]="assetscolor.ERROR" (click)="viewAssetList('ERROR',clients.id,clients.company_name)">{{clients.errorAssetCount}}</button><img src="./assets/arrow-{{clients.avg_error_status}}-solid1.png">
                  <div  dataText="Total Assets">{{clients.offlineAssetCount+clients.healthyAssetCount+clients.unhealthyAssetCount+clients.errorAssetCount}}</div>
                </div>
                <!-- <div id="{{clients.id}}" class="statusAssets"></div> -->
                <!-- <div class="actions dropdown right" style="margin-left: auto;">
                  <button class="btn dropdown-toggle" type="button" [matMenuTriggerFor]="menu" data-toggle="dropdown">
                    <span class="sprite_icon ellipse_black"></span>
                  </button>
                  <mat-menu #menu="matMenu">
                    <div class="client_action">
                      <a class="dropdown-item" (click)="editClient(clients.id)">Edit</a>
                      <a class="dropdown-item" (click)="showDeleteDialog(clients.id, idx)">Delete</a>
                    </div>
                  </mat-menu>
                </div> -->

              </div>
              <!-- <app-assets-count [data]="allClients"></app-assets-count> -->

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
